import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_CREATE_CUSTOMER } from 'constants/urls';

const createCustomer = async (customerData: Record<string, unknown>) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANTRACK_CREATE_CUSTOMER,
      data: { payload: customerData },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[createCustomer] Failed:', error);
    throw error;
  }
};

export default createCustomer;
